import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { UserAdmin } from '../../models/admin';

@Injectable({
  providedIn: 'root',
})
export class ServiceSupportUtils {
  currentUser: UserAdmin | undefined;
  groupCode: string | undefined;

  constructor(private readonly datePipe: DatePipe) {}

  /**
   * To get current date in MM/dd/yyyy format
   *
   * @return {*}  {string}
   * @memberof ServiceSupportUtils
   */
  getMonthFirstFormattedDate(date: Date | null): string {
    let currentDate;
    if (date) {
      currentDate = this.datePipe.transform(date, 'MM/dd/yyyy');
    }
    return currentDate ?? '';
  }
}
